import { render, staticRenderFns } from "./DocumentoTerrestre.vue?vue&type=template&id=436b654a&scoped=true"
import script from "./DocumentoTerrestre.vue?vue&type=script&lang=js"
export * from "./DocumentoTerrestre.vue?vue&type=script&lang=js"
import style0 from "./DocumentoTerrestre.vue?vue&type=style&index=0&id=436b654a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b654a",
  null
  
)

export default component.exports